// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"c9260f0d","647":"84c220e2"}[chunkId] + ".chunk.js";
};